import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["animated", "button", "playPauseText", "play", "pause"];

  declare readonly playPauseTextTarget: HTMLButtonElement;
  declare readonly animatedTargets: Array<HTMLElement>;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly playTarget: SVGElement;
  declare readonly pauseTarget: SVGElement;

  toggle(e: Event): void {
    const target = e.target as HTMLButtonElement;
    const isRunning = target.dataset.autoplay === "true";

    this.buttonTarget.dataset.autoplay = isRunning ? "false" : "true";

    this.playPauseTextTarget.textContent = isRunning ? "Play" : "Pause";
    this.playTarget.classList.toggle("d-none", !isRunning);
    this.pauseTarget.classList.toggle("d-none", isRunning);

    this.animatedTargets.forEach((target) => {
      target.style.animationPlayState = isRunning ? "paused" : "running";
    });
  }
}
